import apiClient from '../apiClient';

class FeedbackService {
  /**
   * Submit feedback. Returns the created feedback record (with `id`).
   * payload: {
   *   raterProfileType, raterProfileId?, raterName?,
   *   ratedProfileId, ratedProfileType,
   *   jobId?, applicationId?,
   *   ratings: { q1, q2, q3 },
   *   comment?,
   *   incidentType?,  // 'no_show' | 'no_payment' | 'disrespect' | 'other'
   * }
   */
  async createFeedback(payload) {
    return apiClient.post('/feedback', payload);
  }

  /**
   * Request presigned URLs for evidence files attached to an incident report.
   * files: [{ fileName, mimeType }]
   */
  async uploadAttachments(feedbackId, files) {
    return apiClient.post(`/feedback/${feedbackId}/attachments`, { files });
  }

  async getFeedbackForProfile(profileId) {
    return apiClient.get(`/feedback/profile/${profileId}`);
  }

  async getMyFeedback() {
    return apiClient.get('/feedback/mine');
  }

  /**
   * Convenience: submit feedback + (optionally) upload evidence files in one call.
   */
  async submitWithEvidence(payload, files = []) {
    const created = await this.createFeedback(payload);
    if (files.length > 0) {
      const meta = files.map((f) => ({
        fileName: f.name,
        mimeType: f.type || 'application/octet-stream',
      }));
      const { uploadUrls } = await this.uploadAttachments(created.id, meta);
      await Promise.all(
        uploadUrls.map((info, idx) =>
          fetch(info.uploadUrl, {
            method: 'PUT',
            body: files[idx],
            headers: { 'Content-Type': files[idx].type || 'application/octet-stream' },
          }),
        ),
      );
    }
    return created;
  }
}

const feedbackService = new FeedbackService();
export default feedbackService;
